// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------

import styled from 'styled-components';

export const SetupCompleteAnimation = styled.div`
  background-image: url(data:image/webp;base64,UklGRi4KAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);

  @keyframes clip-animation {
    0% {
      background-image: url(data:image/webp;base64,UklGRi4KAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    25% {
      background-image: url(data:image/webp;base64,UklGRi4KAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    25% {
      background-image: url(data:image/webp;base64,UklGRpAPAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    50% {
      background-image: url(data:image/webp;base64,UklGRpAPAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    50% {
      background-image: url(data:image/webp;base64,UklGRqIPAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    75% {
      background-image: url(data:image/webp;base64,UklGRqIPAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    75% {
      background-image: url(data:image/webp;base64,UklGRuAUAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    100% {
      background-image: url(data:image/webp;base64,UklGRuAUAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
  }
`;

export const NonEnglishSetupAnimation = styled.div`
  background-image: url(data:image/webp;base64,UklGRvQIAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);

  @keyframes clip-animation {
    0% {
      background-image: url(data:image/webp;base64,UklGRvQIAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    25% {
      background-image: url(data:image/webp;base64,UklGRvQIAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    25% {
      background-image: url(data:image/webp;base64,UklGRtQKAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    50% {
      background-image: url(data:image/webp;base64,UklGRtQKAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    50% {
      background-image: url(data:image/webp;base64,UklGRmIMAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    75% {
      background-image: url(data:image/webp;base64,UklGRmIMAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    75% {
      background-image: url(data:image/webp;base64,UklGRtAJAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt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);
    }
    100% {
      background-image: url(data:image/webp;base64,UklGRtAJAABXRUJQVlA4WAoAAAAQAAAA+QAAOwEAQUxQSDYBAAABkHPbtrE9+7Nt
q2Vr27ZtG0n+gG2rNtqks1HZLs3X3OWJiAlA+h/S0yH+E/+J/8R/4j/xn/hP/Cf+
E/+J/8R/4j/xn/hP/CeMSyMugbVEIJq1eCCEtTDA9hdnP2wB3OLsOgAc4OyEwhJn
ywolnOUqWHxh7JOtAk4zdg5KRxkbUOb1la9fbspwka+zUJnHV5Yq3GfrHtTMYqtW
HYsrXN2A2hlc5aiH7UzthoYe73h67KsJsngqgOZrWFoLbR7l6Cy06vCQoavu2oHn
TX5uhkDbodfZeeQF7ftd4uakC3S6gZktFtBx12tWPndD92GnOLkcBb1sfcnH02ro
q8v0ey4+z7pCj+0nH/HwYNwN+p545CkDr7clwDATFk+9Nue+HF9MgkGHplYOz61a
Y2avmulvSg62gq4BVlA4IHQIAACwRgCdASr6ADwBPm00lUikIqIiIXEsIIANiWlu
4W5xD1GivN6oNuJ4zP7Ae8BpgHoAdJj/k/+NlQPl//H9wf985YKVZSB/pPYT/J99
8qUHEyQVYv0D2AP5F/ffRazzPVe/6/bf2TR83bSw2e0U/bt+HiuxWx8PMGPJGmud
9w5RCr3F533DlEVi+sbwazNwPgfA+B8D3TidMCUdAcjUGW/4/jyx+nupYyFLcis6
DDKTLlW9j9JSBltBwjSjXzzAN1RJhdHm+THeRMuMc6I7bobDAlJCJwHaSMESyJ8L
qQ+LVJkPb9A6QE7N1W3MPRVe2uOvmFiHsWOb9fxs23UIUbFxm8yBr6Ngmmo9jW2t
YTRQYDb8eolWPHBs6Ux+81tWwhjZY7zbrrQJ1ZR17N6ZFw/GfLvAEdFLVOIMJlxQ
rWDELHWmnjqhwXQxUgrm7gNr/q9mIMOBGwPdX6w5ttRPszdrdBl8tc/Rxfbff623
bJMCaCdVOsUYf2e6iadrCsW63io6JOohlgiTnFoNk4pYkMoJ0MnkMQqycvYI1vwf
L/EztQaUvlhxGWmAWVGlvbffZ1EYZ3hRU16HDJ1EMh7uD+xC/WaTDbjE3WygQkGz
c7AhGnp5LqJeYufR9+20eyTRfqcHJYL5ST2gSdaeY/FSUgQVdkc3SSSG7mhcrEAA
6XQ12IRiZ0YTBsAYt7U5sUOn2lGB8D4HwHRST3WSWETmZhHen1qZFqEiGrhKDuc3
d6hYkPgzjOJCglLm6sriUZQAAP4tzbrV82Ma9+JVaT+pHH/4M2Ja9XEvC9337L/4
a/SfqCyHyYnId/A3Wegt8yWrHidgfo7YSg7ElN0OgpUHyIFfpK2+DErgbs9wiUoV
jwD0AvX0T4JmF8Q9EV3DJwOJLfe2Qqe7KZsGhbpsq4bwMnuzPcMB8ckr2AkTmdqE
tOk0wXR3uBBe6fIkKhIRC9e0zgislp12+Xl/geC7y0TTWm/nsX4dKXWobTaVlgYk
IWS0E4xmAqV//D2sSiWNm7sDgz2tGsXN6B5bkN4k5VXtrHbXgUymOBFmsHd8JDhc
6nx+AS3EptDu2MhCtF28zYAZglf9IpRo1pufA01i3I7doE0OU6x4ALOfQzTToAzn
eEYlrV4qf9hkkwObIXpZim1jFh6yOsbm5/MKDlafaVAF2qKB/YpiCgUjuwEzweNo
ozLPIEGg253gANdViyRj+m4gexZQ4ZpiDAByrKqPpokN/UPs2aEYvoL8LLF/dwi0
PpIOtxm5v6wGdHRxk+j+a81KFp1El5IzNCXuq98sAa7xJJyPaxMbBMl0XBjappwL
6QdRqfb8BFlBsVp1ay7Bdx6Az/+LjzVx35VTQGroIv5EAiI1KBII64KOt+Ro0Bwp
sKrERjzysetEaHCmBxjOMleTVbl23JNYvnzDu0HRb0/oTGR9dOHRvYocMLxyLpBQ
jnT+Qy/MwHQI9uNaQK8z2RKRmgzqIS2DOQ/jCPQSpRB1FSwdPPyxYh5E7wAluVaA
Wclws2XDynfzlwVrPGZ38vBm/WSpfRIZ5Sffd9LPls/8U/4pOeZdYP/osCZQmdXJ
a85BP/WXEetnuJ0zDjJ3GGDSUzL6hLpKHXTLeofH7/41v3ep4oG67nN+WYHdSS/5
R4TsInPr8/q8PLczYVv2MzLIJI/kkwIlREda2yf5Ql2GgFq8Ismxk+4rx2K2Wzdj
oQmQSaGx3OE490gYV386FJ+qU+ajIJafpyAdA5TBtfd47cDZBzxNZ7NVSdceP6Z3
5fIJi6U9om/tbw/fgLbNi7PVZWQ6mP9rjOb2lbiYrittR1QLVOu4PDEXLuQtVJbk
991lDFlqhOrTI6la/CULw+fZSrGtIFfCNjmSuNCMo3ZZ7iBOc3oiqVmwchFqACWq
e6hSOVEVZPv+naP19G75fXKWlW9BcQqsgcBztqnYrER+WkL1NAU9YXFQpyueTKIT
1angChwjFd/oFj4+Xn30ccA0Co5LPHMH3kzod+1q57Yux/8qll1Hx9J1YWp73ybn
grRFMCEJGkKyj9/SDfTEjNWN+NOoQUX4rM25ol0xC82NemNIMu3yIo2lzKVqcKHC
n68SgxQ+ORyGZ57QUB5rxy6oOLhhYX0huZMsvZKAcUQo1P0frNjB804mCFODe3Sa
hVU8jIjiE6gxlNuPUx/PfdilwCnr4r2ufxySvVIcrWZ2oS5qSMLbiIGoAeSlBKkX
mJ/EHsavACLyQyW5g4UKFbI+McLilomdkynzpu5W/0N55x95JEPRU48hIuY8RGKQ
vt6ufABwUEeCDG4jbgObCk/rlsE9R0TqNO2oi4oWnVDwyisOSNHzw67pyRgXUR2w
RUa9wC0kX0b/f6VRGQ82vjwLY7N27i7yyfsThL12PX/S0CvzS8b59aIgkAR7+/ie
a/lDPMFPgmeyZWGx/ThX5/5Y5u72Lwluf5CFfn30I793WVpj97Cc9dx6IPk+uTI7
0QbSURaGxJUf6GcxRG1F07CSovwVXnYrkLBg4RTiTtuHZxzvxeX90+fTEdGRo/e5
vZGxY65KNEuPSvjfNdJo8MY4M4CHnUyyfEPCwVLVIm0w+tTFi7s4tmmImFgM1IOP
N/AUgXbnK8zWANQES+nlr6jUhwK/8dgwi+THh3CuvUAUmuHD1HyNYt5xSvv+7XA1
tvWGNGVqADYozPle1jyceZrazeM4j5JZxOnjpoJceIfXw36lgVg64MVQ7Tf9bxxG
DRJFqA6b4kIXEO0ZX7PBf7KFNxalkrk5eKlT4QgBckWtFBjD41l9wqCG5wXRlMG4
sP+6QqJy7JzM1mduS0LEeslgenjeJBnEuH+A+oJtTedqc6zrg7/Ml6e6r6bMUYzw
uOM2+J9HRx7ARlKuNWD/9q6Lf3TOAAAA);
    }
  }
`;
